import { Component, OnInit, Inject } from "@angular/core";
import { ActivityAdjustmentGet, ActivityAdjustmentService } from "../../services/activity-adjustment.service";
import { CrewPermissionsService } from "../../core/crew-permissions.service";
import { map, switchMap } from "rxjs/operators";
import { Observable, BehaviorSubject } from "rxjs";
import moment = require("moment");
import { Moment } from "moment";

import * as dataCore from "../../core/datacore";

@Component({
    selector: "adjustments",
    template: require('./adjustments.component.html')
})
export class AdjustmentsComponent implements OnInit {

    constructor(
        private activityAdjustmentService: ActivityAdjustmentService,
        private crewPermissionsService: CrewPermissionsService,
        @Inject("year") private year: number,
        @Inject("month") private month: number) { }

    fromDate: Moment;

    toDate: Moment;

    items: Observable<ActivityAdjustmentGet[]>;

    isLoading = false;
    isPermissionWriteOrAdmin: Observable<boolean>;

    private readonly refreshSubject = new BehaviorSubject(null);

    ngOnInit(): void {
        this.isPermissionWriteOrAdmin = this.crewPermissionsService.isPermissionWriteOrAdmin();

        let m: Moment;

        if (this.year && this.month) {
            m = moment(new Date(this.year, this.month))
        }
        else {
            m = moment();
        }

        this.fromDate = m.startOf("month");
        this.toDate = moment(this.fromDate).add(1, "month").add(-1, "day");

        this.items = this.refreshSubject.asObservable().pipe(
            switchMap(() => {
                this.isLoading = true;
                return this.activityAdjustmentService.getActivityAdjustments(this.fromDate, this.toDate);
            }),
            map(res => {
                const items = new Array<ActivityAdjustmentGet>(...res.body);

                items.sort((a, b) => {
                    const dayDiff = a.Day.diff(b.Day);

                    if (dayDiff !== 0) {
                        return dayDiff;
                    }

                    return dataCore.compareStrings(
                        a.PersonSortTag,
                        b.PersonSortTag,
                        () => dataCore.compareStrings(
                            a.PersonName,
                            b.PersonName,
                            () => dataCore.compareStrings(
                                a.WorkplaceSortTag,
                                b.WorkplaceSortTag,
                                () => dataCore.compareStrings(
                                    a.WorkplaceName,
                                    b.WorkplaceName))));
                });

                this.isLoading = false;

                return items;
            }));
    }

    refreshItems(): void {
        this.refreshSubject.next(null);
    }

    getDayDisplayValue(d: Moment): string {
        return d.format("DD-MM-YYYY");
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/activities/adjustments/adjustments.component.ts